import { Select } from "components/base/Form";

const PlanTypeSelector = ({ value, onChange, ...rest }) => (
  <Select value={value} onChange={onChange} {...rest}>
    <option value="AB_LTD_SALES_ORDER">AB / LTD Sales Order</option>
    <option value="AB_INTERNAL_TRANSFER">AB Internal Transfer</option>
    <option value="INC_FOB_ORDER">Inc FOB Order</option>
    <option value="INC_STOCK_ORDER">Inc Stock Order</option>
    <option value="INC_AMAZON_SELLER_CENTRAL_ORDER">
      Inc Amazon Seller Central Order
    </option>
  </Select>
);

export default PlanTypeSelector;
